import { isObject } from '../utils.mjs';

function isAbortError(error) {
    return isObject(error) && error['name'] === 'AbortError';
}

export { isAbortError };
